var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate3DScene(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 96 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4469 1.72353H5.78304C3.72063 1.72353 2.04872 3.39544 2.04872 5.45784V17.5422C2.04872 19.6046 3.72063 21.2765 5.78303 21.2765H17.4469C19.5093 21.2765 21.1812 19.6046 21.1812 17.5422V5.45784C21.1812 3.39544 19.5093 1.72353 17.4469 1.72353ZM5.78304 0C2.76875 0 0.325195 2.44356 0.325195 5.45784V17.5422C0.325195 20.5564 2.76875 23 5.78303 23H17.4469C20.4612 23 22.9048 20.5564 22.9048 17.5422V5.45784C22.9048 2.44356 20.4612 0 17.4469 0H5.78304Z",
    fill: "#59B8BE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6889 5.66404L6.9463 7.7418C6.65422 7.90462 6.41106 8.14268 6.24207 8.43125C6.07309 8.71981 5.98445 9.04836 5.98536 9.38276V13.4138C5.98456 13.7481 6.07325 14.0765 6.24223 14.365C6.41121 14.6534 6.65431 14.8914 6.9463 15.0542L10.6902 17.1326C10.9687 17.2875 11.2821 17.3689 11.6008 17.3689C11.9195 17.3689 12.233 17.2875 12.5115 17.1326L16.2554 15.0548C16.5474 14.892 16.7906 14.6539 16.9596 14.3653C17.1286 14.0768 17.2172 13.7482 17.2163 13.4138V9.38276C17.2171 9.04847 17.1284 8.72005 16.9594 8.43161C16.7904 8.14316 16.5473 7.9052 16.2554 7.74243L12.5115 5.66404C12.233 5.50907 11.9195 5.42773 11.6008 5.42773C11.2821 5.42773 10.9687 5.50907 10.6902 5.66404H10.6889Z",
    stroke: "#59B8BE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6003 10.6446L16.5027 7.69958L17.1684 8.80767L12.2466 11.7643V17.3628H10.954V11.7643L6.03223 8.80767L6.69787 7.69958L11.6003 10.6446Z",
    fill: "#59B8BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate3DScene);
export default __webpack_public_path__ + "static/media/create-3d-scene.697aec830e6b9f36c78a84646276ff0d.svg";
export { ForwardRef as ReactComponent };